import React, { useContext } from 'react';
import { ControlProps, GroupBase, components } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';
import Checkbox from 'v2/common/CheckBox/Checkbox';
import _ from 'lodash';
import styles from './ControlComponent.module.scss';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

function ControlComponent<T>(
  props: ControlProps<SelectOption<T>, true, GroupBase<SelectOption<T>>>
) {
  const { currentState, setCurrentState } = useContext(
    CurrentStateFilterContext
  );
  return (
    <div className={styles.control}>
      <components.Control {...props} />
      <Checkbox
        key={`selectAll-${props.selectProps.id}`}
        keyText={`selectAll-${props.selectProps.id}`}
        checked={currentState.is_all}
        label={'Select All'}
        onChange={() => {
          setCurrentState((previous) => {
            const currentStateClone = _.cloneDeep(previous);
            currentStateClone.is_all = !currentState.is_all;
            if (!currentState.is_all) {
              currentStateClone.list = [];
            }
            return currentStateClone;
          });
        }}
      />
    </div>
  );
}

export default ControlComponent;
